import React from 'react'
import {NavHeadLinks} from '../../components/modules/pannelli/HeadLink';
import {MenuMobile} from '../../components/modules/pannelli/MenuMobile';
import {useThemes} from '../../components/hooks/hooks-mongoDB/useThemes';
import simSomXS from '../../components/images/tastewines/intestato/DegustationW500.png';
import simSomS from '../../components/images/tastewines/intestato/DegustationW800.png';
import simSomM from '../../components/images/tastewines/intestato/DegustationW1200.png';
import simSomL from '../../components/images/tastewines/intestato/DegustationW1600.png';
import simSomXL from '../../components/images/tastewines/intestato/DegustationW2000.png';
import simSomXXL from '../../components/images/tastewines/intestato/DegustationW3500.png';

function SimulatorSommelier() {
    const {themes} = useThemes();
    const simulTheme = themes[10];
    return (
        <section>
        <NavHeadLinks title={simulTheme.name} picB={simSomXS}  picS={simSomS} picM={simSomM} picL={simSomL} picXL={simSomXL} picXXL={simSomXXL} />
        <div className="accordion--map">
            <div className = "container--title">
                <h1 className = "title__top"> {simulTheme.name} </h1>
            </div>
        </div>
        <MenuMobile temi={themes}/>
    </section>
    )
}
export default SimulatorSommelier;
